import styled from "styled-components";
import { Colors } from "../../../untils/Theme";


export const FormGroupWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
`
export const FormGroup = styled.div`
    display: flex;
    background-color: ${Colors.seaBlueTransparent};
    border-radius:0.4rem;
    padding:1rem 0 ;
`